<template>
    <div>
        <a-form layout="inline" :form="form" class="myform" @keyup.enter.native="handleSubmit">

            <a-form-item label="数据源">
                <a-select show-search v-model="searchP.source" placeholder="请选择"  allow-clear style="width: 150px">
                    <a-select-option v-for="d in sourceList" :key="d.value">
                        {{ d.label }}
                    </a-select-option>
                </a-select>
            </a-form-item>

            <a-form-item label="关键字">
                <a-input v-model="searchP.keyword"></a-input>
            </a-form-item>
            <a-form-item>
                <a-button type="primary" @click="handleSubmit">查询</a-button>
            </a-form-item>
        </a-form>
    </div>
</template>

<script>

export default {
    components:{
    },
    data(){
        return {
            form: this.$form.createForm(this),
            searchP:{
                keyword:'',
                source:'gd'
            },
            sourceList:[
                {
                    value:'gd',
                    label:'高德地图'
                },
                {
                    value:'tx',
                    label:'腾讯地图'
                }
            ]
        }
    },
    methods:{
        handleSubmit(){
            this.$emit("handleSearch",this.searchP);
        }
      
    },
    mounted(){
        this.handleSubmit()
    }
}

</script>

<style>
    .myform{
        margin-bottom: 20px;
    }
</style>

